import { render, staticRenderFns } from "./app-form-item.vue?vue&type=template&id=804b3afa&scoped=true&"
import script from "./app-form-item.vue?vue&type=script&lang=js&"
export * from "./app-form-item.vue?vue&type=script&lang=js&"
import style0 from "./app-form-item.vue?vue&type=style&index=0&id=804b3afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804b3afa",
  null
  
)

export default component.exports